import { EmailPreferences, User } from "types/User";
import AolPreference from "./AolPreference";
import PageHeader from "../PageHeader";

type AolPreferencesProps = Pick<User, 'accessRoles'> & {
  preferences: EmailPreferences
} 

export default function AolPreferences ({ accessRoles, preferences }: AolPreferencesProps) {
  const keys = Object.keys(preferences) as (keyof EmailPreferences)[]
  const preferencesForms = keys
    .filter((key) => accessRoles.some(accessRole => accessRole.match(`${key}_news`)))
    .map((key) => <AolPreference key={`${key}-email-preferences`} aolPreference={preferences[key]} />)

  return (
    <>
      <PageHeader margin="my6" title='News email preferences' />
      {preferencesForms}
    </>
  )
}